<template>
    <form class="row parts-services g-3" v-on:submit.prevent="SubmitParts">
        <template v-if="this.submitSuccess">
            <div class="col-12">
                <span class="success">{{this.partsServicesSuccess}}</span>
            </div>
        </template>
        <template v-if="this.submitFailure">
            <div class="col-12">
                <span class="failure">{{this.inputFormSubmitFailure}}</span>
            </div>
        </template>
        <div v-if="!this.submitSuccess">
        <div class="row">
            <div class="col-md-3">
                <div class="form-group">
                    <select id="parts" name="parts" class="form-control" v-model="parts">
                        <option value="" label="Please select" selected="selected"></option>
                        <option value="parts" label="Parts"></option>
                        <option value="service" label="Service"></option>
                    </select>
                    <label for="parts" class="form-label">{{formLabel.partsService}}</label>
                    <div class="error">
                        <template v-if="v$.parts.$error">
                            <span v-for="(err, index) in v$.parts.$errors" :key="index" class="error text-danger validate">
                                {{ err.$message }}
                            </span>
                        </template>
                    </div>
                </div>
            </div>
        </div>
        <div class="row">
            <div class="col-md-3">
                <div class="form-group">
                    <input type="text"
                           class="form-control"
                           id="year"
                           placeholder=" "
                           v-model="v$.caseObj.microsite_Model_Year_Submitted__c.$model"
                           @blur="v$.caseObj.microsite_Model_Year_Submitted__c.$touch()" />
                    <label for="year" class="form-label">{{formLabel.year}}</label>
                    <div class="error">
                        <template v-if="v$.caseObj.microsite_Model_Year_Submitted__c.$error">
                            <span v-for="(err, index) in v$.caseObj.microsite_Model_Year_Submitted__c.$errors" :key="index" class="error text-danger validate">
                                {{ err.$message }}
                            </span>
                        </template>
                    </div>
                </div>
            </div>
            <div class="col-md-3">
                <div class="form-group">
                    <input type="text"
                           class="form-control"
                           id="model"
                           placeholder=" "
                           v-model="v$.caseObj.microsite_Model_Submitted__c.$model"
                           @blur="v$.caseObj.microsite_Model_Submitted__c.$touch()" />
                    <label for="model" class="form-label">{{formLabel.model}} </label>
                    <div class="error">
                        <template v-if="v$.caseObj.microsite_Model_Submitted__c.$error">
                            <span v-for="(err, index) in v$.caseObj.microsite_Model_Submitted__c.$errors" :key="index" class="error text-danger validate">
                                {{ err.$message }}
                            </span>
                        </template>
                    </div>
                </div>
            </div>
            <div class="col-md-6">
                <div class="form-group">
                    <input type="text"
                           class="form-control"
                           id="hin"
                           placeholder=" "
                           v-model="caseObj.hiN__c" />
                    <label for="hin" class="form-label">Hull # </label>
                </div>
            </div>
        </div>
        <div class="row" v-if="this.parts == 'parts'">
            <div class="col-md-3">
                <div class="form-group">
                    <input type="text"
                           class="form-control"
                           id="partNo"
                           placeholder=" "
                           v-model="v$.caseObj.part_Number_1__c.$model"
                           @blur="v$.caseObj.part_Number_1__c.$touch()" />
                    <label for="partNo" class="form-label">Part #</label>
                    <div class="error">
                        <template v-if="v$.caseObj.part_Number_1__c.$error">
                            <span v-for="(err, index) in v$.caseObj.part_Number_1__c.$errors" :key="index" class="error text-danger validate">
                                {{ err.$message }}
                            </span>
                        </template>
                    </div>
                </div>
            </div>
            <div class="col-md-9">
                <div class="form-group">
                    <input type="text"
                           class="form-control"
                           id="partDescription"
                           placeholder=" "
                           v-model="v$.caseObj.part_1_Description__c.$model"
                           @blur="v$.caseObj.part_1_Description__c.$touch()" />
                    <label for="partDescription" class="form-label">{{formLabel.partDescription}}</label>
                    <div class="error">
                        <template v-if="v$.caseObj.part_1_Description__c.$error">
                            <span v-for="(err, index) in v$.caseObj.part_1_Description__c.$errors" :key="index" class="error text-danger validate">
                                {{ err.$message }}
                            </span>
                        </template>
                    </div>
                </div>
            </div>
        </div>
        <div class="row" v-if="this.parts == 'service'">
            <div class="col-md-12 pb-5">
                <h2>Preferred Appointment Time</h2>
            </div>
            <div class="col-md-3">
                <div class="form-group">
                    <input type="date"
                           class="form-control"
                           id="appointment-date"
                           placeholder=" "
                           v-model="appointmentDate"
                           @blur="v$.appointmentDate.$touch()"
                           name="appointmentDate"
                           :min="new Date().toISOString().split('T')[0]"
                           :max="getMaxDate" />
                    <label for="appointment-date" class="form-label">Date mm/dd/yyyy</label>
                    <div class="error">
                        <template v-if="v$.appointmentDate.$error">
                            <span v-for="(err, index) in v$.appointmentDate.$errors" :key="index" class="error text-danger validate">
                                {{ err.$message }}
                            </span>
                        </template>
                    </div>
                </div>
            </div>
            <div class="col-md-9">
                <div class="form-group">
                    <input type="time"
                           class="form-control"
                           id="appointment-time"
                           placeholder=" "
                           v-model="appointmentTime"
                           @blur="v$.appointmentTime.$touch()" />
                    <label for="appointment-time" class="form-label">{{formLabel.time}}</label>
                    <div class="error">
                        <template v-if="v$.appointmentTime.$error">
                            <span v-for="(err, index) in v$.appointmentTime.$errors" :key="index" class="error text-danger validate">
                                {{ err.$message }}
                            </span>
                        </template>
                    </div>
                </div>
            </div>
        </div>
        <div class="row">
            <div class="col-md-12">
                <div class="form-group">
                    <textarea type="text"
                              class="form-control form-textarea"
                              rows="3"
                              id="additionalInfo"
                              placeholder=" "
                              v-model="caseObj.description" />
                    <label for="additionalInfo" class="form-label">{{formLabel.additionalInfo}}</label>
                </div>
            </div>
        </div>
        <div class="row">
            <div class="col-12 pb-4">
                <h2>{{formLabel.yourInformation}}</h2>
            </div>
        </div>
        <div class="row">
            <div class="col-md-3">
                <div class="form-group">
                    <input type="text"
                           class="form-control"
                           id="fname"
                           placeholder=" "
                           v-model="v$.caseObj.first_Name__c.$model"
                           @blur="v$.caseObj.first_Name__c.$touch()" />
                    <label for="fname" class="form-label">{{formLabel.firstName}}</label>
                    <div class="error">
                        <template v-if="v$.caseObj.first_Name__c.$error">
                            <span v-for="(err, index) in v$.caseObj.first_Name__c.$errors" :key="index" class="error text-danger validate">
                                {{ err.$message }}
                            </span>
                        </template>
                    </div>
                </div>
            </div>
            <div class="col-md-3">
                <div class="form-group">
                    <input type="text"
                           class="form-control"
                           id="lname"
                           placeholder=" "
                           v-model="v$.caseObj.last_Name__c.$model"
                           @blur="v$.caseObj.last_Name__c.$touch()" />
                    <label for="lname" class="form-label">{{formLabel.lastName}}</label>
                    <div class="error">
                        <template v-if="v$.caseObj.last_Name__c.$error">
                            <span v-for="(err, index) in v$.caseObj.last_Name__c.$errors" :key="index" class="error text-danger validate">
                                {{ err.$message }}
                            </span>
                        </template>
                    </div>
                </div>
            </div>
        </div>
        <div class="row">
            <div class="col-md-3">
                <div class="form-group">
                    <input type="email"
                           class="form-control"
                           id="email"
                           placeholder=" "
                           v-model="v$.caseObj.suppliedEmail.$model"
                           @blur="v$.caseObj.suppliedEmail.$touch()" />
                    <label for="email" class="form-label">{{formLabel.email}}</label>
                    <div class="error">
                        <template v-if="v$.caseObj.suppliedEmail.$error">
                            <span v-for="(err, index) in v$.caseObj.suppliedEmail.$errors" :key="index" class="error text-danger validate">
                                {{ err.$message }}
                            </span>
                        </template>
                    </div>
                </div>
            </div>
            <div class="col-md-3">
                <div class="form-group">
                    <input type="tel"
                           class="form-control"
                           id="phone"
                           placeholder=" "
                           v-model="caseObj.suppliedPhone" />
                    <label for="phone" class="form-label">{{formLabel.phone}}</label>
                </div>
            </div>
        </div>
        <div class="row">
            <div class="col-md-12">
                <div class="form-group">
                    <input type="text"
                           class="form-control"
                           id="address"
                           placeholder=" "
                           v-model="caseObj.address_1__c" />
                    <label for="address" class="form-label">{{formLabel.streetAddress}}</label>
                </div>
            </div>
        </div>
        <div class="row">
            <div class="col-md-8">
                <div class="container p-0">
                    <div class="row">
                        <div class="col-md-12">
                            <div class="form-group">
                                <input type="text"
                                       class="form-control"
                                       id="city"
                                       placeholder=" "
                                       v-model="caseObj.city__c" />
                                <label for="city" class="form-label">{{formLabel.city}}</label>
                            </div>
                        </div>
                    </div>
                    <div class="row">
                        <div class="col-md-6">
                            <div class="form-group">
                                <states-dropdown :CountryCode="this.country"
                                       v-model="state"
                                       :onchange="selectedState"
                                       id="state" />
                                <label for="state" class="form-label">{{formLabel.state}}</label>
                            </div>
                        </div>
                        <div class="col-md-6">
                            <div class="form-group">
                                <input type="text"
                                       class="form-control"
                                       id="zipcode"
                                       placeholder=" "
                                       v-model="caseObj.postal_Code__c" />
                                <label for="zipcode" class="form-label">{{formLabel.zipcode}}</label>
                            </div>
                        </div>
                    </div>
                    <div class="row">
                        <div class="col-md-12">
                            <div class="form-group">
                                <country-dropdown v-model="country"
                                         :oncountryload="InitialSelect"
                                         :onchange="selectedCountry" />
                                <label for="country" class="form-label">{{formLabel.country}}</label>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="col-md-4">
                <div class="form-group">
                    <textarea type="text"
                              class="form-control form-textarea"
                              rows="7"
                              id="message"
                              placeholder=" "
                              v-model="caseObj.comments__c" />
                    <label for="message" class="form-label">{{formLabel.message}}</label>
                </div>
            </div>
        </div>
        <div class="col-md-12">
            <button class="btn-submit" value="Submit" type="submit" :disabled="isSubmitting">{{formLabel.submit}}</button>
        </div>
        <div class="hidden">
            <input type="hidden"
               id="loading-time"
               name="loading-time"
               :value="this.unixTimestamp" />
            <input type="text"
               style="display: none"
               id="hpValue"
               name="hpValue"
               v-model="hpvalue" />
        </div>
        </div>
    </form>
</template>
<script>
    import CountryDropdown from "../atoms/CountryDropdown.vue";
    import StatesDropdown from "../atoms/StatesDropdown.vue";
    import getEndPoint, { caseAPI } from "../../constants/api.config";
    import { salesforcecase } from "../../constants/form-model-config";
    import useValidate from "@vuelidate/core";
    import {inputFormSubmitFailure, partsServicesSuccess, formLabel} from '../../constants/labels.config'
    import {
        required,
        email,
        helpers,
        requiredIf,
    } from "@vuelidate/validators";
    export default {
        name: "PartsAndServices",
        components: {
            CountryDropdown,
            StatesDropdown,
        },
        data() {
            return {
                v$: useValidate(),               
                state: "",
                country: "",
                parts: "",
                appointmentDate:null,
                appointmentTime: null,
                requestTime: "",
                hpvalue: "",
                caseID: "",
                caseObj: { ...salesforcecase },
                submitSuccess: false,
                submitFailure: false,
                partsServicesSuccess,
                inputFormSubmitFailure,
                isSubmitting:null,
                formLabel
            };
        },
        validations() {
            return {
                parts: {
                    required: helpers.withMessage("Parts or services required", required),
                },
                appointmentDate:{
                    required: helpers.withMessage(
                            "Appointment date required",
                            requiredIf(function () {
                                return this.parts == "service";
                            })
                        ),
                },
                appointmentTime:{
                     required: helpers.withMessage(
                            "Appointment time required",
                            requiredIf(function () {
                                return this.parts == "service";
                            })
                        ),
                },
                caseObj:{
                    first_Name__c: {
                        required: helpers.withMessage("First name required", required),
                    },
                    last_Name__c: {
                        required: helpers.withMessage("Last name required", required),
                    },
                    suppliedEmail: {
                        required: helpers.withMessage(
                            "Email address required",
                            required
                        ),
                        email: helpers.withMessage("Invalid email address", email),
                    },
                    microsite_Model_Year_Submitted__c: {
                        required: helpers.withMessage("Year required", required),
                    },
                    microsite_Model_Submitted__c: {
                        required: helpers.withMessage("Model required", required),
                    },
                    part_Number_1__c: {
                        required: helpers.withMessage(
                            "Part# required",
                            requiredIf(function () {
                                return this.parts == "parts";
                            })
                        ),
                    },
                    part_1_Description__c: {
                        required: helpers.withMessage(
                            "Part description required",
                            requiredIf(function () {
                                return this.parts == "parts";
                            })
                        ),
                    },
                }
            };
        },
        computed: {
            unixTimestamp: function () {
                return Math.round(new Date().getTime() / 1000);
            },
            getMaxDate: function () {
                const dt = new Date();
                dt.setMonth(dt.getMonth() + 1);
                return dt.toISOString().split("T")[0];
            },
        },
        methods: {
            selectedCountry: function (event) {
                this.country = event.target.value;
            },
            InitialSelect: function (data) {
                this.country = data;
            },
            selectedState: function (event) {
                this.state = event.target.value;
            },
            SubmitParts(e) {
                this.submitSuccess = false;
                this.submitFailure = false;
                this.isSubmitting=true;
                this.v$.$validate();
                if (this.v$.$error) {
                    this.isSubmitting=false;
                    for (var i = 0; i < this.v$.$errors.length; i++) {
                        console.log(this.v$.$errors[i].$message);
                    }
                    return;
                }
                
                this.caseObj.state__c = this.state != "" ? this.state : document.getElementById("state").value;
                this.caseObj.country__c = this.country;
                this.caseObj.Appointment_Date__c = this.appointmentDate;
                this.caseObj.Appointment_Time__c = this.appointmentTime?.toString();
                this.caseObj.Parts_or_Service__c = this.parts;
                this.caseObj.Subject = this.parts;
                this.caseObj.honeyPot = this.hpvalue;
                this.caseObj.requestTime = document.getElementById("loading-time").value;
                console.log(this.caseObj);
                console.log("Case endpoint: ", getEndPoint(caseAPI));
                this.axios
                    .post(getEndPoint(caseAPI), this.caseObj)
                    .then((response) => {
                            this.caseID = response.data.id;
                            this.submitSuccess = true;
                            this.submitFailure = false;
                            this.isSubmitting = false;
                        })
                    .catch((error) => {
                        this.submitFailure = true;
                        this.submitSuccess = false;
                        this.isSubmitting = false;
                        console.error("There was an error!", error);
                    });
                e.preventDefault();
            },
        },
    };
</script>